/**
* Team Members JS
* -----------------------------------------------------------------------------
*
* All the JS for the Team Members component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'team-members',
    memberArray: $( '#team-members__popup' ).data( 'members' ),
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const _this = this;

      $( '.team-members-btn, .member_nav_btn' ).on( 'click', function() {
        const memberID = $( this ).data( 'id' );

        $.post(
            site_info.ajax_url,
            {
              action: 'll_run_function',
              function: 'll_team_members_info',
              params: {
                member_id: memberID,
              },
            },
            function( data, textStatus, xhr ) {
              data = $.parseJSON( data );
              if ( data.status === 'success' ) {
                console.log( data.response );
                _this.getMembersNav( memberID );
                $( '#team_name' ).text( data.response.name );
                $( '#team_title' ).text( data.response.title );
                $( '#team_content' ).html( data.response.about );
                $( '#team_image' ).html( data.response.image );
              }
            }
        );
      } );
    },
    finalize: function() {

    },
    pad: function( str, max ) {
      str = str.toString();
      return str.length < max ? this.pad( '0' + str, max ) : str;
    },
    getMembersNav: function( memberID ) {
      const memberArrayIdx = this.memberArray.indexOf( memberID );
      let prevMember;
      let nextMember;

      if ( memberArrayIdx === 0 ) {
        prevMember = this.memberArray[this.memberArray.length - 1];
        nextMember = this.memberArray[memberArrayIdx + 1];
      } else if ( memberArrayIdx === this.memberArray.length - 1 ) {
        prevMember = this.memberArray[memberArrayIdx - 1];
        nextMember = this.memberArray[0];
      } else {
        prevMember = this.memberArray[memberArrayIdx - 1];
        nextMember = this.memberArray[memberArrayIdx + 1];
      }

      $( '#member_prev' ).data( 'id', prevMember );
      $( '#member_next' ).data( 'id', nextMember );

      $( '#member_count' ).text( this.pad( memberArrayIdx + 1, 2 ) + '/' + this.pad( this.memberArray.length, 2 ) );
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'team-members', COMPONENT );
} )( app );
